import HistoryCheckField from 'Components/VehicleHistory/HistoryCheckField/HistoryCheckField';
import { triggerHistoryCheckModalCloseEvent, triggerHistoryCheckModalOpenedEvent } from 'Services/analytics/events';

import { useVehicleMainInfo } from '../../MainInfoSection/useVehicleMainInfo';
import { useVehicleDetails } from '../useVehicleDetails';

const historyCheckEvents = {
	onModalClose: triggerHistoryCheckModalCloseEvent,
	onModalOpen: triggerHistoryCheckModalOpenedEvent,
};

export const HpiCheckFieldValue: React.FC = () => {
	const { make, model, prettyVrm } = useVehicleMainInfo();
	const { hpiHistoryCheck } = useVehicleDetails();

	return (
		<HistoryCheckField
			events={historyCheckEvents}
			historyChecks={hpiHistoryCheck || undefined}
			make={make}
			model={model}
			prettyVrm={prettyVrm}
		/>
	);
};
